import React from 'react';
import './edit-catalogue.scss';
import {
  IconButton,
} from '@material-ui/core';
import { EditOutlinedIcon } from 'components/icons/edit-outlined';
import { useNavigation } from 'react-navi';
import { EditCatalogueProps } from './edit-catalogue-props';

/**
 * A link to edit an existing catalogue.
 *
 * Important: This Material-UI `Link` uses the base `a` component instead of the
 * react-navi `Link` to allow window.onbeforeunload functionality as the
 * react-navi `Link` will not unload the window on route change.
 * @param props
 */
export const EditCatalogue: React.FC<EditCatalogueProps> = (props) => {
  const {
    id,
    disabled,
    type,
  } = props;

  const navigation = useNavigation();
  const edit = () => {
    const { search } = navigation.getCurrentValue().url;
    const href = `/catalogue/edit/${id}${search}&type=${type}`;
    window.location.href = href;
  };

  return (
    <div className="sg-edit-catalogue">
      <IconButton color="secondary" disabled={disabled} onClick={edit}>
        <EditOutlinedIcon color={disabled ? 'disabled' : 'primary'} />
      </IconButton>
    </div>
  );
};
